import React from "react";

import { cn } from "@/lib/utils";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export function FormSelect({
  value,
  onValueChange,
  placeholder,
  options,
  icon: Icon,
  triggerClassName,
  contentClassName,
  itemClassName,
  disabled = false,
  testId,
}) {
  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger
        data-testid={testId}
        className={cn(
          "h-12 rounded-xl border border-primary/45 bg-muted px-3 text-left text-sm font-medium shadow-none transition-colors duration-200 focus:border-primary/45 focus:bg-muted focus:ring-0 focus:ring-offset-0 [&>span]:flex-1 [&>span]:text-left",
          triggerClassName
        )}
      >
        {Icon ? (
          <div className="mr-3 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg border border-primary/10 bg-primary/[0.07] text-primary">
            <Icon className="h-3.5 w-3.5" />
          </div>
        ) : null}
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent
        className={cn(
          "rounded-xl border border-border bg-popover p-1 shadow-md outline-none focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0",
          contentClassName
        )}
      >
        {options.map((option) => {
          const normalizedOption =
            typeof option === "string"
              ? { label: option, value: option }
              : option;

          return (
            <SelectItem
              key={normalizedOption.value}
              value={normalizedOption.value}
              className={cn(
                "rounded-md outline-none focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0",
                itemClassName
              )}
            >
              {normalizedOption.label}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}

export default FormSelect;
